import React from "react";
import "./style.css";

export default function About() {
    return (
        <div id="about" className="about mx-auto">
            <h2 className="text-center mb-4 mt-2">About The Baker</h2>
            <div className="row mt-2">
                <div className="col-lg-3 col-xl-3 mx-auto mb-2 pic">
                    <img className="mx-auto bioPic img-fluid" src="/pictures/family.jpg" alt="christy"></img>
                </div>
                <div className="col-lg-9 col-xl-9 mx-auto">
                    <p className="mx-auto text-left bio">Baked by Drake began when Christy Drake made king cakes for friends
                    while living in Lubbock, TX.  King Cakes turned into a cake and cupcake business and later settled into decorated sugar cookies.
                    Christy creates "Decorated Sugar Cookies for Every Occasion" and can make any theme or inspiration come to life.
                    She has her own special recipe which customers testify to tasting great, matching the professionalism of her designs.
                    Contact Christy now to create a cookie experience for your next special gathering.  Christy and her family
                    live in Jersey Village</p>
                </div>
            </div>
        </div>
    )
}